import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    GraduationCap,
    Stars,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    BookType,
    FlaskConical,
    Microscope,
    Stethoscope,
    FileText,
    Download,
    User,
    FileDigit,
    ShieldCheck,
    Users2,
    FileCheck,
    School,
    ArrowRight,
    Beaker,
    Trophy, Atom, Zap, Shield, LucideSearch, Activity, CheckCircle,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';
import Dean from "../../../assets/pharmacy/Dean.jpg";
import Antiraging from "../../../assets/pharmacy/Anti Ragging Committee.pdf";
import GenderSensitizationCommittee from "../../../assets/pharmacy/Gender Sensitization Committee.pdf";
import bpharmastudents from "../../../assets/pharmacy/List of  Students B.Pharma 2024.pdf";
import Dpharmastudents from "../../../assets/pharmacy/List of  Students D.Pharma 2024.pdf";
import why from '../../../assets/schools/pharma/RKT02733.webp';

import Result from "../../../assets/schools/pharma/B Pharma Result.pdf";
// import bioresult from "../../../assets/pharmacy/BPharma - 2024 1st Semester _BIO.pdf";
// import mathresult from "../../../assets/pharmacy/BPharma -2024 1st Semester _MATH.pdf";
import pci from "../../../assets/pharmacy/pci 2023-24.pdf";
import {
    TbPlant2,
    TbWorldWww,
    TbSchool,
    TbFlask,
    TbUsers,
    TbBriefcase,
    TbLeaf,
    TbTrophy,
    TbAward,
    TbQuote,

} from "react-icons/tb";
import { Target, Eye } from "lucide-react";
import { useState } from "react";
import PlacementPartners from '../../../components/PlacementImg';

import aayushman from '../../../assets/schools/pharma/Aayushman.webp';
import Abhinav from '../../../assets/schools/pharma/Abhinav Rawat.webp';
import Analisha from '../../../assets/schools/pharma/Analisha Debbarma.jpg';
import AayushmanAward from '../../../assets/schools/pharma/ayushman.jpg';
import AayushmanCertificate from '../../../assets/schools/pharma/aayushman_certificate.png';
import Danish1 from '../../../assets/schools/pharma/Danish.webp';
import Danish from '../../../assets/schools/pharma/danish 2.webp';
import DanishCertificate from '../../../assets/schools/pharma/danish_certificate.png';
import sustain_certificate from '../../../assets/schools/pharma/sustain certificate.png';

import pharma1 from '../../../assets/schools/pharma/pharma1.webp';


import patent1 from '../../../assets/schools/pharma/patent1.webp';
import patent2 from '../../../assets/schools/pharma/patent2.webp';
import patent3 from '../../../assets/schools/pharma/patent3.webp';
import patent4 from '../../../assets/schools/pharma/patent4.webp';



import Durgesh from '../../../assets/schools/pharma/Durgesh.png';
import Jeewan from '../../../assets/schools/pharma/Jeewan.png';
import Khushboo from '../../../assets/schools/pharma/Khushboo.webp';
import Kuldeep from '../../../assets/schools/pharma/Kuldeep.png';
import Kuldeepkumar from '../../../assets/schools/pharma/Kuldeep kumar.jpg';
import Mahak from '../../../assets/schools/pharma/Mahak.webp';
import Rashmi from '../../../assets/schools/pharma/Rashmi.png';
import RashmiSharma from '../../../assets/schools/pharma/Rashmi Sharma.jpg';
import Ravi from '../../../assets/schools/pharma/Ravi.png';
import Rushan from '../../../assets/schools/pharma/Rushan Debbarma.webp';
import Salka from '../../../assets/schools/pharma/Salka Mark Debbarma.webp';
import Suhail from '../../../assets/schools/pharma/Suhail.png';
import Aastha from '../../../assets/schools/pharma/Aastha.png';
// import Suhail from '../../../assets/schools/pharma/Suhail Bashir  khan.webp';

import sun from '../../../assets/placement comp/placement companies/sun.png';
import adoma from '../../../assets/placement comp/placement companies/adoma.png';
// import astellas from '../../../assets/placement comp/placement companies/adoma.png';
// import aurobindo from '../../../assets/placement comp/placement companies/aurobindo.tif';

import PharmaLogoSlider from '../../../components/PharmaLogoSlider';

const pharmacyCourses = {
    Diploma: [
        { name: "Diploma in Pharmacy (D.Pharm)", path: "best-d-pharma-college-in-dehradun-uttarakhand" },
    ],
    undergraduate: [
        { name: "Bachelor of Pharmacy (B.Pharm)", path: "best-b-pharma-colleges-in-dehradun-uttarakhand" },
        { name: "Bachelor of Pharmacy - LE", path: "bachelor-pharmacy-lateral-entry" }
    ],
    postgraduate: [
        { name: "M.Pharm - Pharmaceutics", path: "/programmes/pg-courses/pharmacy/master-pharmacy-pharmaceutics" },
        { name: "M.Pharm - Pharmaceutical Chemistry", path: "/programmes/pg-courses/pharmacy/master-pharmacy-pharmaceutics-chemistry" },
        { name: "M.Pharm - Pharmacology", path: "/programmes/pg-courses/pharmacy/master-pharmacy-pharmacology" }
    ],
    doctorate: [
        { name: "Pharm D (Doctor of Pharmacy)", path: "/programmes/phd-courses/pharmacy/DoctorPharmacy" }
    ]
};

// PDF Resources
const pdfResources = [
    {
        title: "Regulatory Approvals",
        icon: <ShieldCheck className="w-5 h-5 md:w-6 md:h-6" />,
        documents: [
            {
                name: "PCI Approval 2023-24",
                description: "Pharmacy Council of India Official Approval Document",
                path: pci, // Use the imported file directly
                icon: <FileCheck className="w-4 h-4" />
            }
        ]
    },
    {
        title: "Academic Results",
        icon: <FileDigit className="w-5 h-5 md:w-6 md:h-6" />,
        documents: [
            {
                name: "B. Pharma Results 2024",
                description: "Official examination results for B.Pharma",
                path: Result,
                icon: <School className="w-4 h-4" />
            },
            // {
            //     name: "B.Pharma 1st Semester Results 2024 (Math Result)",
            //     description: "Official examination results for B.Pharma first semester",
            //     path: mathresult,
            //     icon: <School className="w-4 h-4" />
            // }
        ]
    },
    {
        title: "Institutional Committees",
        icon: <Users2 className="w-5 h-5 md:w-6 md:h-6" />,
        documents: [
            {
                name: "Anti-Ragging Committee",
                description: "Members and guidelines of the Anti-Ragging Committee",
                path: Antiraging,
                icon: <ShieldCheck className="w-4 h-4" />
            },
            {
                name: "Gender Sensitization Committee",
                description: "Members and guidelines of the Gender Sensitization Committee",
                path: GenderSensitizationCommittee,
                icon: <Users2 className="w-4 h-4" />
            }
        ]
    },
    {
        title: "Student Information",
        icon: <User className="w-5 h-5 md:w-6 md:h-6" />,
        documents: [
            {
                name: "Category-wise List of B.Pharma Students 2024",
                description: "Complete list of enrolled students with category classification",
                path: bpharmastudents,
                icon: <Users className="w-4 h-4" />
            },
            {
                name: "Category-wise List of D.Pharma Students 2024",
                description: "Complete list of enrolled students with category classification",
                path: Dpharmastudents,
                icon: <Users className="w-4 h-4" />
            }
        ]
    }
];


const achievements = [
    {
        name: "Aayushman Rauniyar",
        achievement: "Chess(Men)",
        images: {
            profile: AayushmanAward,
            certificate: AayushmanCertificate,
            award: AayushmanAward
        }
    },
    {
        name: "Danish",
        achievement: "Selected in National Floorball championship",
        images: {
            profile: Danish,
            certificate: DanishCertificate,
            award: Danish1
        }
    }
];


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        {/* Overview section with image - side by side on web, stacked on mobile */}
        <div className="flex flex-col lg:flex-row gap-8 items-center mb-10">
            <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <BookOpen className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Overview</h2>
                </div>
                <div className="space-y-4 text-gray-700 text-lg">
                    <p>The Pharmacy department in a Maya Devi University (School of Pharmacy) is an academic unit dedicated to the education, training, and research in the field of pharmaceutical sciences. It plays a crucial role in preparing students to become qualified pharmacists, researchers, and professionals in various sectors of healthcare and industry. It has well equipped laboratories namely Pharmaceutics lab, Pharma-chemistry lab, Human Anatomy and Physiology lab, Pharmacognosy lab, Pharmacology lab, Microbiology lab, Central Instrumentation Lab, Pharmacy Practice lab, Machine Room, Museum. It also has well equipped class rooms with seminar corridor, library with latest text books and Pharmaceutical journals, boys’ common room, girls’ common room, faculty rooms hostel and transport facilities.</p>
                </div>
            </div>
            <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
                <img
                    src={pharma1}
                    alt="School of Pharmacy"
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
                    <div className="p-6">
                        <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
                        <p className="text-white/80 text-sm">Modern classrooms and advanced labs</p>
                    </div>
                </div>
            </div>
        </div>

        {/* Mission section - full width on web, normal on mobile */}
        <div className="w-full mb-10">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Mission</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The mission of the School of Pharmacy is to educate and develop competent, ethical, and compassionate pharmacy professionals who are committed to improving healthcare outcomes. The School aims to provide high-quality education, foster innovative research, and promote community service in the pharmaceutical and healthcare fields. Through academic excellence, practical training, and a focus on lifelong learning, the School strives to empower students to become leaders in pharmacy practice, research, and industry.</p>
            </div>
        </div>

        {/* Vision section - full width on web, normal on mobile */}
        <div className="w-full">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Eye className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Vision</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>Our vision is to become a nationally renowned institution, dedicated to fostering and developing leaders in pharmacy practice, education, and research.</p>
            </div>
        </div>
    </motion.div>
);


const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 my-3 md:my-8 px-4"
    >
        {[
            // { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "7+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "48 LPA", label: "Heighest Package", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "134", label: "Total Number of Students Placed", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);

const TestimonialCard = ({ student, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.2 }}
        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full"
    >
        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
            <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden">
                    <img
                        src={student.image}
                        alt={student.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800">{student.name}</h3>
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Building className="w-3 h-3" />
                        <span>{student.company}</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
            <div className="text-[#0e4d38] mb-3">
                <MessageSquareQuote className="w-6 h-6" />
            </div>
            <p className="text-gray-700 italic flex-1">{student.testimonial}</p>

            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                {student.award && (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Award className="w-4 h-4 text-[#0e4d38]" />
                        <span>{student.role}</span>
                    </div>
                )}
                {/* <div className="text-sm text-gray-500">Class of {student.graduationYear}</div> */}
            </div>
        </div>
    </motion.div>
);

const StudentTestimonials = () => {
    const testimonials = [
        {
            name: "Rashmi Sharma",
            role: "Senior Officer, East African Overseas",
            quote: "It's hard to put into words what this college has given me — knowledge, confidence, friendships, and memories that will last a lifetime.",
            image: RashmiSharma
        },
        {
            name: "Kuldeep Kumar",
            role: "Business Executive, Mankind Pharma",
            quote: "The faculty was supportive, the campus environment inspiring, and the opportunities for growth were endless.",
            image: Kuldeepkumar
        },
        {
            name: "Abhinav Rawat",
            role: "B.Pharm Graduate",
            quote: "The supportive environment and excellent facilities make Maya Devi University a great choice for aspiring pharmacists.",
            image: Abhinav
        },
        {
            name: "Mahak",
            role: "B.Pharm Student",
            quote: "Our faculty members are extremely supportive and always willing to guide us through challenging topics.",
            image: Mahak
        },
        {
            name: "Analisha Debbarma",
            role: "B.Pharm Student",
            quote: "I'm proud to be part of a place that values diversity and supports students from all backgrounds.",
            image: Analisha
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-xl shadow-lg mb-12"
        >
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Users className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Student Testimonials</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.2 }}
                        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full hover:shadow-lg transition-all duration-300"
                    >
                        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
                            <div className="flex items-center gap-3">
                                <div className="w-14 h-14 rounded-full overflow-hidden">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-gray-800">{testimonial.name}</h3>
                                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6 flex-1 flex flex-col">
                            <div className="text-[#0e4d38] mb-3">
                                <TbQuote size={24} />
                            </div>
                            <p className="text-gray-700 italic flex-1">{testimonial.quote}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            {course.name.toLowerCase().includes('pharm d') ? (
                                <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : course.name.toLowerCase().includes('m.pharm') ? (
                                <BookType className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : (
                                <FlaskConical className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            )}
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>
                            {course.name.includes('D.Pharm') ? '2 Years' :
                                course.name.includes('B.Pharm - LE') ? '3 Years' :
                                    course.name.includes('B.Pharm') ? '4 Years' :
                                        course.name.includes('M.Pharm') ? '2 Years' :
                                            course.name.includes('Pharm D') ? '6 Years' : 'Duration'}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>
                            {course.name.includes('M.Pharm') ? 'PG' :
                                course.name.includes('Pharm D') ? 'Doctor' : 'UG'}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>

        {/* Diploma Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Diploma Program</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.Diploma.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>
        {/* Undergraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Undergraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.undergraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Postgraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Postgraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.postgraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Doctorate Programs */}
        <div>
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Doctor Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.doctorate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
        <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
        <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto relative z-10"
        >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
                School of Pharmacy
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
                Shaping Tomorrow's Leaders at Maya Devi University
            </h2>

            <div className="flex flex-wrap gap-4 md:gap-6">
                <Link to="https://admission.maya.edu.in/">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
                    >
                        Apply Now
                        <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link>
                {/* <Link to="#programs">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
                    >
                        Explore Programs
                        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link> */}
            </div>
        </motion.div>
    </div>
);

// Dean Section Component
const DeanSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg overflow-hidden"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                <GraduationCap className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">From the Dean's Desk</h4>
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
            <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="rounded-xl overflow-hidden max-w-[250px]"
                >
                    <img
                        src={Dean}
                        alt="Dr. Vikram Singh - Dean, School of Pharmacy"
                        className="w-[250px] h-[250px] object-contain bg-white rounded-xl shadow-lg"
                    />
                </motion.div>
                <div className="text-center mt-3">
                    <h5 className="font-bold text-lg text-gray-800">Dr. Vikram Singh</h5>
                    <p className="text-sm text-gray-600">Dean, School of Pharmacy</p>
                </div>
            </div>

            <div className="w-full md:w-2/3 lg:w-3/4 flex flex-col justify-center h-full">
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    Welcome to the School of Pharmacy at Maya Devi University. Our mission is to educate and train the next generation of pharmacy professionals who will lead innovation in pharmaceutical care and research.
                </p>
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    Our curriculum integrates theoretical knowledge with practical experience, preparing students to excel in diverse healthcare settings. We emphasize evidence-based practice, critical thinking, and ethical conduct while fostering a collaborative learning environment.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    The faculty at our School of Pharmacy brings together academic excellence and industry experience to provide students with a comprehensive education that meets the evolving needs of the pharmaceutical and healthcare sectors.
                </p>
            </div>
        </div>
    </motion.div>
);


const StudentAchievements = () => {
    return (
        <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-extrabold text-center mb-4 text-indigo-900 tracking-tight">
                    Student Achievements
                </h2>
                <p className="text-xl text-center text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
                    Celebrating the remarkable achievements of our students
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {achievements.map((student, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300"
                        >
                            <div className="relative">
                                <img
                                    src={student.images.profile}
                                    alt={`${student.name} profile`}
                                    className="w-full h-64 object-cover"
                                />
                            </div>
                            <div className="p-6">
                                <h3 className="text-2xl font-bold text-gray-800 mb-2">{student.name}</h3>
                                <p className="text-gray-700 bg-indigo-50 p-3 rounded-lg mb-4">
                                    <span className="font-semibold">Achievement:</span> {student.achievement}
                                </p>
                                <div className="grid grid-cols-2 gap-4">
                                    <img
                                        src={student.images.certificate}
                                        alt={`${student.name} certificate`}
                                        className="w-full h-full object-cover rounded-lg shadow-sm"
                                    />
                                    <img
                                        src={student.images.award}
                                        alt={`${student.name} award`}
                                        className="w-[200px] h-[250px] object-cover rounded-lg shadow-sm"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};



const PharmacyDepartment = () => {
    // Data for Global Opportunities
    const globalOpportunities = [
        {
            title: "Licensing Exams",
            items: [
                "FPGEE (Foreign Pharmacy Graduate Equivalency Exam)",
                "GPhC Registration Exam (UK)",
                "NAPLEX (USA)",
                "PEBC (Canada)"
            ]
        },
        {
            title: "Higher Education",
            items: [
                "Postgraduate Programs Abroad",
                "Research Fellowships",
                "Ph.D. Opportunities"
            ]
        },
        {
            title: "Certifications",
            items: [
                "Clinical Pharmacy Certification (FCCP)",
                "Pharmaceutical Sciences Certifications",
                "Regulatory Affairs Certifications"
            ]
        }
    ];

    // Placements Data
    const placements = [
        { name: "Durgesh Pandey", company: "Cipla Pharmaceuticals", position: "Assistant Manager", ctc: "5.5 LPA", image: Durgesh },
        { name: "Rashmi Sharma", company: "East African Overseas", position: "Senior Officer", ctc: "3.3 LPA", image: Rashmi },
        { name: "Kuldeep Kumar", company: "Mankind Pharma", position: "Business Executive", ctc: "5 LPA", image: Kuldeep },
        { name: "Ravi Kumar", company: "NKG Advisory", position: "Officer", ctc: "1.8 LPA", image: Ravi },
        { name: "Suhail Bashir Khan", company: "Govt District Hospital", position: "Pharmacist", ctc: "4.80 LPA", image: Suhail },
        { name: "Jeewan Chandra Joshi", company: "Zee Lab Ltd", position: "Sr Executive", ctc: "6.90 LPA", image: Jeewan },
        { name: "Aastha Shrivastava", company: "International Modern Hospital Dubai", position: "Pharmacist", ctc: "15 LPA", image: Aastha }
    ];

    // Companies Data (using placeholder images)
    const companies = [
        { name: "Sun Pharma", logo: sun },
        { name: "Adoma", logo: adoma },
        // { name: "Astellas", logo: astellas }
    ];


    // Patents Data
    const patents = [
        "Dissolution Testing Apparatus To Simulate Colonic BioEnvironment",
        "Portable Electro Spinning Device For Development Of Nanofibres",
        "T-Maze Apparatus For Detection Of Locomotor Activity",
        "Variable Speed Rotating Drum",
        "Oil Filled Coverslip For Microscope",
        "Gas Chromatography Mass Spectrometer Apparatus",
        "Modified Silverson Mixer Emulsifier For Nanoparticle Synthesis"
    ];

    // Clubs Data
    const clubs = [
        {
            name: "Sports Club",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Art and Culture Club",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "Health Care Management Club",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },
        {
            name: "Clean and Green Club",
            icon: <TbLeaf size={24} />,
            description: "Promotes environmental awareness through sustainability initiatives."
        },
        {
            name: "Women Empowerment Club",
            icon: <TbUsers size={24} />,
            description: "Advocates for gender equality and women's professional growth."
        }
    ];

    // Testimonials Data
    const testimonials = [
        {
            name: "Rashmi Sharma",
            role: "Senior Officer, East African Overseas",
            quote: "It's hard to put into words what this college has given me — knowledge, confidence, friendships, and memories that will last a lifetime.",
            image: Rashmi
        },
        {
            name: "Kuldeep Kumar",
            role: "Business Executive, Mankind Pharma",
            quote: "The faculty was supportive, the campus environment inspiring, and the opportunities for growth were endless.",
            image: Kuldeep
        },
        {
            name: "Abhinav Rawat",
            role: "B.Pharm Graduate",
            quote: "The supportive environment and excellent facilities make Maya Devi University a great choice for aspiring pharmacists.",
            image: Abhinav
        },
        {
            name: "Mahak",
            role: "B.Pharm Student",
            quote: "Our faculty members are extremely supportive and always willing to guide us through challenging topics.",
            image: Mahak
        },
        {
            name: "Analisha Debbarma",
            role: "B.Pharm Student",
            quote: "I'm proud to be part of a place that values diversity and supports students from all backgrounds.",
            image: "/api/placeholder/300/300"
        }
    ];

    // State for active testimonial
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [showCertificate, setShowCertificate] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);


    // const patents = [
    //     "Novel Drug Delivery System",
    //     "Sustained Release Formulation",
    //     "Targeted Therapy Mechanism",
    //     "Bioavailability Enhancement",
    //     "Anti-inflammatory Compound",
    //     "Nanoparticle Drug Carrier"
    //   ];

    // Separate certificate images
    const certificateImages = [
        patent1,
        patent2,
        patent3,
        patent4
    ];

    // Add this component before the PharmacyDepartment component

    const InfiniteSlider = ({ placements }) => {
        return (
            <div className="relative">
                {/* Mobile View - Grid Layout */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {placements.map((student, index) => (
                        <div
                            key={`mobile-${index}`}
                            className="w-full h-full flex justify-center items-center"
                        >
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                <div className="relative overflow-hidden h-72 w-full">
                                    <img
                                        src={student.image}
                                        alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                        <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                        {student.name && (
                                            <p className="text-white text-xs">{student.name}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop View - Infinite Slider */}
                <div className="hidden md:block overflow-hidden w-full">
                    <div className="flex animate-infinite-scroll">
                        {/* First set */}
                        {placements.map((student, index) => (
                            <div
                                key={`first-${index}`}
                                className="flex-shrink-0 w-[300px] mx-4"
                            >
                                <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                    <div className="relative overflow-hidden h-72 w-full">
                                        <img
                                            src={student.image}
                                            alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                            loading="lazy"
                                        />
                                        {/* <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                            <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                            {student.name && (
                                                <p className="text-white text-xs">{student.name}</p>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Second and third sets remain the same */}
                        {/* ... existing second and third sets code ... */}
                    </div>
                </div>
            </div>
        );
    };


    const WhyUsSection = () => {
        const features = [
            {
                icon: <Zap className="w-7 h-7" />,
                title: "Strong Academic Foundation:",
                description: "We deliver high-quality education through wellstructured programs, qualified faculty, and a modern curriculum aligned with industry standards. "
            },
            {
                icon: <Shield className="w-7 h-7" />,
                title: "Practical Learning: ",
                description: "Emphasis on hands-on training, laboratory work, internships, and field exposure ensures students gain real-world skills. "
            },
            {
                icon: <Globe className="w-7 h-7" />,
                title: "Experienced Faculty: ",
                description: "Our team of supportive educators guides students academically and mentors them for future success. "
            },
            {
                icon: <LucideSearch className="w-7 h-7" />,
                title: "Modern Infrastructure:",
                description: "State-of-the-art laboratories, well-stocked libraries, digital classrooms, and student-friendly campus facilities foster a comfortable learning environment."
            },
            {
                icon: <Users className="w-7 h-7" />,
                title: "Industry Linkages:",
                description: "Strong connections with leading pharmaceutical companies and a 300-bed multi-specialty hospital enhance clinical exposure and career development. "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Holistic Development: ",
                description: "Extracurricular activities, sports, and cultural events help students develop confidence, leadership, and teamwork skills."
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Affordable Education: ",
                description: "Quality education at a reasonable cost, with scholarships available for meritorious students. "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Inclusive Campus: ",
                description: "A safe, diverse environment where students from different backgrounds feel welcome and supported. "
            }
        ];

        return (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-lg mb-12"
            >
                <div className="flex flex-col md:flex-row gap-8">
                    <div className="w-full md:w-1/3">
                        <div className="sticky top-24">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                                    <CheckCircle className="w-6 h-6" />
                                </div>
                                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Join Us?</h2>
                            </div>
                            <p className="text-gray-700 mb-6">The School of Pharmacy at Maya Devi University offers a dynamic educational environment that blends academic excellence with practical experience. Here’s why joining us can be a valuable step for your personal and professional growth: </p>
                            <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
                                <img
                                    src={why}
                                    alt="Students collaborating"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
                                    <p className="text-white font-semibold">Joining Maya Devi University means becoming part of a progressive academic community dedicated to shaping future leaders, professionals, and innovators. </p>
                                </div>
                            </div>
                            <div className="mt-6">
                                <Link to="https://admission.maya.edu.in/">
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
                                    >
                                        Apply Now
                                        <ArrowRight className="w-5 h-5" />
                                    </motion.button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-2/3">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.1 }}
                                    className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                                >
                                    <div className="text-[#0e4d38] mb-4">
                                        <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
                                            {feature.icon}
                                        </div>
                                    </div>
                                    <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3>
                                    <p className="text-gray-600">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        );
    };

    // Function to move to next testimonial
    const nextTestimonial = () => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    // Function to move to previous testimonial
    const prevTestimonial = () => {
        setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const viewCertificate = (index) => {
        setSelectedIndex(index);
        setShowCertificate(true);
    };

    const closeCertificate = () => {
        setShowCertificate(false);
    };
    return (
        <div className="font-sans">

            {/* 4. Global Opportunities Section */}
            <section className="py-16 bg-gradient-to-r from-emerald-800 to-emerald-600 text-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold mb-4 flex items-center justify-center">
                            <TbWorldWww className="mr-3" /> Global Opportunities
                        </h2>
                        <p className="text-xl max-w-3xl mx-auto">
                            Our pharmacy students have pathways to international careers through various global qualifications and programs.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {globalOpportunities.map((opportunity, index) => (
                            <div key={index} className="bg-white bg-opacity-10 p-8 rounded-xl backdrop-blur-sm border border-white border-opacity-20 hover:bg-opacity-20 transition-all hover:transform hover:scale-105 duration-300">
                                <h3 className="text-2xl font-semibold mb-4">{opportunity.title}</h3>
                                <ul className="space-y-3">
                                    {opportunity.items.map((item, i) => (
                                        <li key={i} className="flex items-start">
                                            <span className="inline-block bg-emerald-400 rounded-full w-2 h-2 mt-2 mr-3"></span>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 5.	Program Names:  */}
            <div className="space-y-6 md:space-y-8">
                <Department
                    title="Pharmacy Programs"
                    icon={<Microscope className="w-5 h-5 md:w-6 md:h-6" />}
                />
            </div>

            {/* Dean Section */}
            <DeanSection />

            {/* 7.Students' Achievements / Placements:  */}
            <section className="py-20 bg-gradient-to-b from-gray-50 to-gray-100">
                <div className="container mx-auto px-4">
                    <div className="mb-14 text-center">
                        <h2 className="text-4xl font-bold mb-5 text-emerald-800 relative inline-block">
                            Student Placements
                            {/* <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-emerald-500 rounded-full"></span> */}
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our graduates are making an impact in prestigious organizations worldwide
                        </p>
                    </div>

                    {/* Infinite Slider */}
                    <div className="overflow-hidden">
                        <InfiniteSlider placements={placements} />
                    </div>
                </div>
            </section>

            {/* <PlacementPartners /> */}
            <PharmaLogoSlider />

            <WhyUsSection />


            {/*10. Awards & Patents Section - Modernized with green theme */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    {/* Heading */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-emerald-800 mb-4 flex items-center justify-center">
                            <Trophy className="mr-3" /> Awards &  Recognitions
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our department's achievements in research and development
                        </p>
                    </div>

                    {/* Patents and Recognition Row */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Department Patents Section */}
                        <div className="bg-emerald-50 p-8 rounded-xl shadow-sm">
                            <h3 className="text-2xl font-semibold mb-6 text-emerald-700">
                                Department Patents
                            </h3>
                            <ul className="space-y-4">
                                {patents.map((patent, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="bg-emerald-600 text-white rounded-full w-7 h-7 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                            {index + 1}
                                        </span>
                                        <span className="text-gray-800">
                                            {patent}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Department Recognition Section */}
                        <div className="bg-emerald-50 p-8 rounded-xl shadow-sm text-center">
                            <div className="bg-emerald-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                                <Trophy size={28} />
                            </div>

                            <img
                                src={sustain_certificate}
                                alt="Department Recognition"
                                className="mx-auto mb-6 rounded-lg shadow-md max-h-64 object-cover"
                            />
                            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
                                Department Recognition
                            </h3>
                            <p className="text-gray-600">
                                Our department has been recognized for excellence in research and innovation
                            </p>
                        </div>
                    </div>
                </div>
            </section>



            {/* 11. Clubs Section - Modernized with green theme */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    {/* Section Heading */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-emerald-800 mb-4">Student Clubs</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Engage beyond academics with our vibrant student organizations
                        </p>
                    </div>

                    {/* Club Overview Cards */}
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
                        {clubs.map((club, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                                <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white p-6 flex items-center">
                                    <div className="text-3xl mr-4">{club.icon}</div>
                                    <h3 className="text-xl font-bold">{club.name}</h3>
                                </div>
                                <div className="p-6">
                                    <p className="text-gray-600">{club.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Detailed Descriptions */}
                    {/* <div className="space-y-12">
                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Sports Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Sports Club at School of Pharmacy is dedicated to promoting physical fitness, teamwork, and a healthy competitive spirit among students. Despite the rigorous academic demands of pharmacy education, we believe that sports and recreational activities play a vital role in maintaining mental and physical well-being.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Our club organizes regular intra- and inter-college tournaments in various sports such as cricket, football, badminton, volleyball, table tennis, and athletics. We also encourage participation in university-level competitions and sports meets. Through these activities, students not only stay active but also develop leadership, discipline, and camaraderie.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The Sports Club is open to all students, and we welcome both beginners and experienced athletes. Join us to balance your academic life with energy, passion, and fun on the field!
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Art and Culture Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Art and Culture Club is a vibrant and inclusive platform that celebrates creativity, diversity, and self-expression. It aims to bring together individuals who are passionate about various forms of art, music, dance, literature, drama, and cultural traditions.


                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The club serves as a space where members can explore their artistic talents, share ideas, and engage in meaningful cultural activities. It organizes workshops, exhibitions, performances, and cultural festivals that highlight both modern and traditional art forms.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through participation in the club, members not only enhance their creative skills but also develop confidence, teamwork, and a deeper appreciation for the rich cultural heritage of different communities. The Art and Culture Club plays a vital role in enriching the overall experience of students and promoting a lively, expressive, and culturally aware environment.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Health Care Management Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Health Care Management Club is a professional and educational platform that brings together students interested in the administrative, managerial, and leadership aspects of the healthcare industry. The club aims to bridge the gap between clinical knowledge and management skills, preparing future leaders in health systems and services.


                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through guest lectures, workshops, seminars, and industry interactions, the club exposes members to real-world healthcare challenges, policy-making, hospital administration, public health strategies, and health economics. It also fosters networking opportunities with healthcare professionals and organizations.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                The club encourages innovation, critical thinking, and problem-solving to address modern health care issues. Whether you're aiming for a career in hospital management, public health, pharmaceutical administration, or health policy, this club offers valuable insights and experiences to support your journey.
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Clean and Green Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Clean and Green Club is dedicated to promoting environmental awareness and sustainability within the campus and the community. The club encourages students to take active roles in protecting nature through initiatives that support cleanliness, green practices, and eco-friendly living.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Our activities include tree plantation drives, waste management campaigns, cleanliness drives, recycling initiatives, awareness programs, and participation in national and global environmental observances like Earth Day and World Environment Day.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                By fostering a sense of responsibility toward the environment, the Clean and Green Club aims to inspire long-term habits that contribute to a cleaner, healthier, and more sustainable planet. Join us in making a difference—one green step at a time!
                            </p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-emerald-700 mb-2">Women Empowerment Club</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The Women Empowerment Club is committed to promoting gender equality, empowering women, and creating a safe, supportive, and inclusive environment for all. The club serves as a platform to raise awareness about women's rights, genderbased issues, and the importance of equal opportunities in education, careers, and society.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                We organize seminars, workshops, self-defense training, inspirational talks, skillbuilding sessions, and campaigns that encourage confidence, leadership, and independence among women. The club also works to engage all genders in conversations around equality, respect, and empowerment.
                            </p>
                            <p className="text-gray-700 leading-relaxed">
                                Through education, dialogue, and action, the Women Empowerment Club strives to inspire positive change and support the personal and professional growth of women in every walk of life.


                            </p>
                        </div>
                    </div> */}
                </div>
            </section>


            {/*12.  StudentTestimonials */}
            <StudentTestimonials testimonials={testimonials} />

            {/* Call to Action */}
            <section className="py-16 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-4xl font-bold mb-6">Begin Your Pharmaceutical Journey</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Join our prestigious School of Pharmacy and become part of the next generation of pharmaceutical innovators.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button className="bg-white text-emerald-800 px-8 py-4 rounded-full font-semibold hover:bg-emerald-50 transition-colors">
                            <Link to="https://admission.maya.edu.in/"> Apply Now </Link>
                        </button>
                        {/* <button className="bg-transparent border-2 border-white hover:bg-white hover:text-emerald-800 px-8 py-4 rounded-full font-semibold transition-all">
                            Schedule a Visit
                        </button> */}
                    </div>
                </div>
            </section>
        </div>
    );
};


// PDF Document Card Component
const DocumentCard = ({ document }) => (
    <motion.div
        whileHover={{ scale: 1.02 }}
        className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300"
    >
        <div className="p-4">
            <div className="flex justify-between items-center mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                    {document.icon}
                </div>
                <a href={document.path} download>
                    <motion.div
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        className="p-2 bg-gray-50 hover:bg-gray-100 rounded-full"
                    >
                        <Download className="w-4 h-4 text-gray-600" />
                    </motion.div>
                </a>
            </div>
            <h3 className="font-semibold text-gray-800 mb-1 text-sm md:text-base">{document.name}</h3>
            <p className="text-gray-600 text-xs md:text-sm mb-3">{document.description}</p>
            <a
                href={document.path}
                download
                className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-[#0e4d38] hover:text-[#0a3b2a] transition-colors"
            >
                Download PDF
                <ArrowUpRight className="w-3 h-3" />
            </a>
        </div>
    </motion.div>
);

// PDF Resources Section
const ResourcesSection = ({ category }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {category.icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{category.title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.documents.map((doc, index) => (
                <DocumentCard key={index} document={doc} />
            ))}
        </div>
    </motion.div>
);

const Pharmacy = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
            <Title canonicalPath="/programmes/ug-courses/pharmacy" />
            <Title title="School of Pharmacy at Maya Devi University, Dehradun" description=" Join the School of Pharmacy at Maya Devi University, Dehradun. Pursue a rewarding career in pharmacy with expert knowledge and practical skills in healthcare." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <AboutSection />
                <Stats />
                <PharmacyDepartment />

                <StudentAchievements />


                {/* PDF Resources Sections */}
                <div className="space-y-6 md:space-y-8">
                    {pdfResources.map((category, index) => (
                        <ResourcesSection key={index} category={category} />
                    ))}
                </div>

                <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "PCI Approved Programs",
                            "Experienced Faculty with Industry Background",
                            "State-of-the-art Laboratories",
                            "Industry-Integrated Curriculum",
                            "Hands-on Training",
                            "Research Opportunities",
                            "Regular Industrial Visits",
                            "Modern Teaching Methods",
                            "Well-equipped Library",
                            "Industry Collaboration",
                            "Mentorship Program",
                            "Career Development Support"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Stethoscope className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Clinical Pharmacist",
                            "Hospital Pharmacist",
                            "Research Scientist",
                            "Drug Safety Associate",
                            "Quality Control Manager",
                            "Regulatory Affairs Officer",
                            "Production Manager",
                            "Medical Writer",
                            "Pharmaceutical Sales",
                            "Drug Inspector",
                            "Academic Researcher",
                            "Healthcare Consultant"
                        ]}
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Pharmacy;